"use client";

import React from "react";
import { Bar, BarChart, CartesianGrid, XAxis, YAxis } from "recharts";
import { Activity, Globe, Info, MapPin, TrendingUp, Users } from "lucide-react";
import { cn } from "@/lib/utils";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Link } from "@/components/common/Link";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Progress } from "@/components/ui/progress";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { Separator } from "@/components/ui/separator";
import { HoverCard, HoverCardContent, HoverCardTrigger } from "@/components/ui/hover-card";
import { ChartContainer, ChartTooltip, ChartTooltipContent } from "@/components/ui/chart";
const trendData = [{
  month: "Jan",
  demand: 1200,
  supply: 900
}, {
  month: "Feb",
  demand: 1900,
  supply: 1100
}, {
  month: "Mar",
  demand: 2400,
  supply: 1300
}, {
  month: "Apr",
  demand: 2100,
  supply: 1600
}, {
  month: "May",
  demand: 2800,
  supply: 1900
}, {
  month: "Jun",
  demand: 3200,
  supply: 2100
}];
const chartConfig = {
  demand: {
    label: "Deployed Workforce",
    color: "#F89406"
  },
  supply: {
    label: "Reserve Talent",
    color: "#FFFFFF"
  }
};
const skillsData = [{
  name: "Logistics & Warehousing",
  density: 92,
  trend: "+14%"
}, {
  name: "Construction & Trade",
  density: 85,
  trend: "+8%"
}, {
  name: "Food Production",
  density: 78,
  trend: "+11%"
}, {
  name: "Agricultural Services",
  density: 74,
  trend: "+6%"
}, {
  name: "Manufacturing Support",
  density: 65,
  trend: "+3%"
}];
const regionsData = [{
  id: "reg-1",
  name: "Scandinavia",
  status: "High Capacity",
  statusVariant: "default" as const,
  activeLearners: "1.2M",
  topSkill: "Logistics & Warehousing",
  growth: "+24%",
  coordinates: "Logistics Node Alpha"
}, {
  id: "reg-2",
  name: "Central Europe",
  status: "Active Deployment",
  statusVariant: "secondary" as const,
  activeLearners: "980K",
  topSkill: "Food Production",
  growth: "+18%",
  coordinates: "Industrial Node Beta"
}, {
  id: "reg-3",
  name: "Eastern Europe",
  status: "Strategic Reserve",
  statusVariant: "outline" as const,
  activeLearners: "2.1M",
  topSkill: "Construction & Trade",
  growth: "+32%",
  coordinates: "Agri-Sector Gamma"
}, {
  id: "reg-4",
  name: "Baltic States",
  status: "Growth Sector",
  statusVariant: "outline" as const,
  activeLearners: "450K",
  topSkill: "Manufacturing",
  growth: "+12%",
  coordinates: "Support Hub Delta"
}];
export default function GlobalSkillsStatistics() {
  const {
    ref: headerRef,
    isVisible: isHeaderVisible
  } = useRevealOnScroll();
  const {
    ref: statsRef,
    isVisible: isStatsVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: regionsRef,
    isVisible: isRegionsVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="101743" id="talent-ecosystem" className="bg-[#0F172A] py-16 md:py-24 overflow-hidden">
      {}
      <div className="dark container mx-auto px-4 md:px-6">
        <div className="relative rounded-3xl bg-[#0F172A] text-white border border-[#343434] shadow-2xl overflow-hidden">
          
          {}
          <div className="absolute inset-0 pointer-events-none opacity-10">
            <div className="absolute inset-0 bg-[linear-gradient(to_right,#F8940612_1px,transparent_1px),linear-gradient(to_bottom,#F8940612_1px,transparent_1px)] bg-[size:24px_24px]" />
            <div className="absolute left-0 right-0 top-0 -z-10 m-auto h-[310px] w-[310px] rounded-full bg-[#F89406] opacity-10 blur-[100px]" />
          </div>

          
        </div>
      </div>
    </section>;
}